export default {
    add(id, caseId, treatmentData, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/add`,
            method: 'POST',
            data: treatmentData
        })
    },
    update(id, caseId, treatmentId, treatmentData, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/update`,
            method: 'POST',
            data: treatmentData
        })
    },
    updateTagt(id, caseId, treatmentId, treatmentData, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/updateTagt`,
            method: 'POST',
            data: treatmentData
        })
    },
    close(id, caseId, treatmentId, remarksData, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/close`,
            method: 'POST',
            data: remarksData
        })
    },
    resume(id, caseId, treatmentId, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/resume`,
            method: 'POST'
        })
    },
    get(id, caseId, treatmentId, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/view`,
            method: 'GET'
        })
    },
    addRevision(id, caseId, treatmentId, revisionData, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/revision/add`,
            method: 'POST',
            data: revisionData
        })
    },
    addRadiograph(id, caseId, treatmentId, radiographData, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/radiograph/add`,
            method: 'POST',
            data: radiographData
        })
    }
}
